import React from "react";
import { makeStyles, TextField } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";

const useStyles = makeStyles((theme) => ({
  inputBox: {
    width: "100%",
    marginBottom: theme.spacing(2),

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        // borderColor:  brandTheme.mainColor,
      },

      "&:hover fieldset": {
        borderColor: brandTheme.mainColor,
      },

      "&.Mui-focused fieldset": {
        borderColor: brandTheme.mainColor,
        borderWidth: "2px",
      },
    },

    // "& .MuiFormLabel-root": {
    //   // color: brandTheme.mainColor,
    // },

    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.mainColor,
      fontWeight: 600,
    },
    '& .MuiOutlinedInput-notchedOutline':{
        // borderColor: brandTheme.mainColor,
    },

    "& .MuiFormLabel-root.Mui-disabled": {
      color: brandTheme.lightBlack,
    },
  },
}));

const CustomTextField = ({ label, placeholder, value, onChange, onBlur, style, disabled, type, maxLength, helperText,error, fullWidth  }) => {
  const classes = useStyles();
  const handleChange = (e) => {
    let inputValue = e.target.value;
  
    // Allow only numeric input OR empty string
    if (type === "number") {
      const regex = /^[0-9\b]*$/; // Note the * instead of + to allow empty string
      if (!regex.test(inputValue)) return;
    }
  
    // Manually enforce maxLength for number type
    if (maxLength && inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }
  
    if (onChange) {
      e.target.value = inputValue;
      onChange(e);
    }
  };
  const handleBlur = (e) => {
    if (onBlur) {
      onBlur(e); // Pass the event to parent component
    }
  };
  return (
    <TextField
    variant="outlined"
    label={label}
    placeholder={placeholder}
    value={value?.toString() || ""}
    onChange={handleChange}
    onBlur={handleBlur}
    fullWidth = {fullWidth}
    className={style ? style : classes.inputBox}
    disabled={disabled}
    inputProps={type !== "number" ? { maxLength } : {}}
    helperText={helperText}
    error={error}
    />
  );
};

export default CustomTextField;